import { t } from "../locale";
import type { Smartplug2 } from "./sp2";

function checkConnection(sp2: Smartplug2): string {
	if (!sp2.ConnectionLost) return "";
	return t.device.card.connectionWarning;
}

function checkConsumption(sp2: Smartplug2): string {
	if (!sp2.ConsumptionNotification.Enabled) return "";
	if (!sp2.ConsumptionNotification.Triggered) return "";
	return t.smartplug.card.consumptionWarning;
}

function checkLoad(sp2: Smartplug2): string {
	if (!sp2.TargetConfig.LoadAlarm.Enabled) return "";

	if (sp2.Load < sp2.TargetConfig.LoadAlarm.Lower) {
		return t.smartplug.card.lowLoadWarning;
	}

	if (sp2.Load > sp2.TargetConfig.LoadAlarm.Upper) {
		return t.smartplug.card.highLoadWarning;
	}

	return "";
}

function checkPower(sp2: Smartplug2): string {
	if (!sp2.PowerFailureNotification.Enabled) return "";
	if (!sp2.PowerFailureNotification.Triggered) return "";
	return t.smartplug.card.powerFailureWarning;
}

export function getSmartplug2Warnings(sp2: Smartplug2): string[] {
	return [
		checkConnection(sp2),
		checkConsumption(sp2),
		checkPower(sp2),
		checkLoad(sp2),
	].filter((text) => text !== "");
}
